import { isShallowEqual } from './is-shallow-equal';
// Poor mans implementation of popular 'memoizeOne' function, very usefull for memoization in selectors
export const memoizeOne = (fn) => {
    let lastCall = { type: 'NONE' };
    return ((...args) => {
        if (lastCall.type === 'SOME' && isShallowEqual(lastCall.args, args)) {
            return lastCall.result;
        }
        const result = fn(...args);
        lastCall = { type: 'SOME', args, result };
        return result;
    });
};
//# sourceMappingURL=memoize-one.js.map